module.exports = __webpack_public_path__ + "img/CM-BS-25-Acura-Playful.7d957747.jpg";